import * as React from 'react';
import { BrochureAttachment as BrochureAttachmentT } from '../../../typedefs/store';
import styled from 'styled-components';
import * as DocumentIcon from 'react-icons/lib/io/document-text';

interface Props {
    attachment: BrochureAttachmentT;
}

interface State {}

class BrochureAttachment extends React.Component<Props, State> {
    viewBrochure = () => {
        if (this.props.attachment.fileUrl) window.open(this.props.attachment.fileUrl, 'new');
    };

    render() {
        const { year, make, model } = this.props.attachment;
        return (
            <Wrapper className="conversations-attachment conversations-attachment-brochure" onClick={this.viewBrochure}>
                <IconWrapper className="conversations-attachment-icon">
                    <DocumentIcon size={32} />
                </IconWrapper>
                <BrochureWrapper className="conversations-attachment-content">
                    {year} {make} {model} Brochure
                </BrochureWrapper>
            </Wrapper>
        );
    }
}

export default BrochureAttachment;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

const IconWrapper = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 10px;
`;
const BrochureWrapper = styled.div`flex-grow: 1;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/BrochureAttachment.tsx